import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { dismissalOrders, type DismissalOrder } from '@/api/hr';
import DataTable, { type ColumnDef } from '@/shared/components/DataTable';

export default function DismissalOrdersPage() {
  const navigate = useNavigate();
  const list = useQuery({
    queryKey: ['dismissal-orders'],
    queryFn: () => dismissalOrders.list({ limit: 200 }),
  });

  const cols = useMemo<ColumnDef<DismissalOrder>[]>(() => [
    { key: 'document_number', header: '№', width: 130, importBadge: true, sortValue: (r) => r.document_number ?? '', cell: (r) => r.document_number },
    { key: 'document_date', header: 'Дата', width: 160, sortValue: (r) => r.document_date ?? '', cell: (r) => r.document_date ? new Date(r.document_date).toLocaleString('uk-UA') : '' },
    { key: 'dismiss_date', header: 'Звільнити з', width: 130, sortValue: (r) => r.dismiss_date ?? '', cell: (r) => r.dismiss_date ? new Date(r.dismiss_date).toLocaleDateString('uk-UA') : '' },
    { key: 'reason_article', header: 'Стаття', width: 200, sortValue: (r) => r.reason_article ?? '', cell: (r) => r.reason_article },
    { key: 'posted', header: 'Проведено', width: 120, align: 'center', sortValue: (r) => r.posted ? 1 : 0, cell: (r) => r.posted ? '✓ так' : 'ні' },
  ], []);

  return (
    <>
      <div className="toolbar">
        <h2 style={{ margin: 0 }}>Накази про звільнення</h2>
        <button className="primary" onClick={() => navigate('/dismissal-orders/new')}>
          + Нове звільнення
        </button>
      </div>
      <DataTable<DismissalOrder>
        rows={list.data?.items ?? []}
        columns={cols}
        rowKey={(r) => r.id}
        loading={list.isLoading}
        emptyText="Немає документів."
        onRowDoubleClick={(r) => navigate(`/dismissal-orders/${r.id}`)}
        rowMuted={(r) => r.deletion_mark ? 0.4 : undefined}
        initialSortKey="document_date"
        initialSortDir="desc"
      />
    </>
  );
}
